import Typography from "@mui/material/Typography";
import * as React from "react";
import BackButton from "../../containers/BackButton";
import Breadcrumbs from "../../containers/Breadcrumbs";
import { useInitialPageLoad } from "../../hooks/useInitialPageLoad";
import CloudFoundryBanner from "../../containers/CloudFoundryBanner";

export default function HelpContentSI() {
  useInitialPageLoad("historical");
  return (
    <>
      <Breadcrumbs currentPageBreadCrumbTitle="Annual Data Summaries" />
      <CloudFoundryBanner />
      <BackButton
        app="Historical"
        buttonLabel="Back to Search Results"
        variant="dark"
      />
      <>
        <Typography variant="h1" id="historical=si-help-title">
          Savings Institution Help
        </Typography>

        <Typography variant="body2" component="div">
          <a href="#INTRODUCTION">INTRODUCTION</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#CONTENTS">CONTENTS</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#DATA SOURCES">DATA SOURCES</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#METHODOLOGY">METHODOLOGY</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#COMPARABILITY OF DATA">COMPARABILITY OF DATA</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#LEVEL OF CONSOLIDATION">LEVEL OF CONSOLIDATION</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#VALIDATION">VALIDATION</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#EXCLUSIONS">EXCLUSIONS</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#DEFINITIONS">DEFINITIONS</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#FDIC-Insured Institutions">FDIC-Insured Institutions</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Charter Class">Charter Class</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Charter Type">Charter Type</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Effective Date">Effective Date</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#FDIC-Insured Commercial Banks">
            FDIC-Insured Commercial Banks
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#FDIC-Insured Savings Institutions">
            FDIC-Insured Savings Institutions
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Cert">Cert</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Failure/Assistance">Failure/Assistance</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Estimated Loss">Estimated Loss</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#COMMENTS, SUGGESTIONS AND REQUESTS">
            COMMENTS, SUGGESTIONS AND REQUESTS
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#DATA AVAILABILITY">DATA AVAILABILITY</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Number of Institutions by Regulatory Agent and Insurance Fund">
            Number of Institutions by Regulatory Agent and Insurance Fund
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Changes in Number of Institutions">
            Changes in Number of Institutions
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Net Income">Net Income</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Interest Income">Interest Income</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Interest Expense">Interest Expense</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Noninterest Income and Noninterest Expense">
            Noninterest Income and Noninterest Expense
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Charge-Offs and Recoveries on Loans/Leases, Cash Dividends and Number of Employees">
            Charge-Offs and Recoveries on Loans/Leases, Cash Dividends and
            Number of Employees
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Assets">Assets</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Investment Securities">Investment Securities</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Loans and Leases">Loans and Leases</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Real Estate Loans">Real Estate Loans</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Field Content">Field Content</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Liabilities and Equity Capital">
            Liabilities and Equity Capital
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Deposits">Deposits</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Interest Earning Assets and Interest Bearing Liabilities">
            Interest Earning Assets and Interest Bearing Liabilities
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Past Due and Nonaccrual Loans/Leases">
            Past Due and Nonaccrual Loans/Leases
          </a>
        </Typography>

        <Typography variant="h2" id="INTRODUCTION">
          INTRODUCTION
        </Typography>
        <Typography variant="body2">
          The Historical Statistics on Banking (HSOB) is intended to be a
          reference and source document for those interested in banking history
          and in performing analyses on major trends in banking. It contains
          both structure and financial data on insured commercial banks and
          savings institutions from the Federal Deposit Insurance Corporation's
          inception in 1934 to the present as well as bank failures and
          assistance transactions. Its primary goal is to provide comprehensive
          industry data about FDIC-insured depository institutions.
        </Typography>

        <Typography variant="body2">
          In addition to the HSOB, the FDIC offers other products that may
          provide more detail and analysis for current and historical data.
          These products include data for individual institutions, summary level
          data and peer group analysis. These products can be found under the
          Bank Data and Statistics or the Research and Analysis pages on the
          FDIC's web site, www.fdic.gov.
        </Typography>

        <Typography variant="body2">
          FDIC.gov {"->"} INDUSTRY ANALYSIS {"->"} Bank Data and Statistics
        </Typography>

        <Typography variant="body2">
          Call Reports and Thrift Financial Reports -
          http://www5.fdic.gov/Call_TFR_Rpts/index.asp
        </Typography>

        <Typography variant="body2">
          Central Data Repository - https://cdr.ffiec.gov/public/
        </Typography>

        <Typography variant="body2">
          Call Reports and Thrift Financial Reports from 2001 to the present for
          individual banks and savings associations are available for viewing
          and downloading.
        </Typography>

        <Typography variant="body2">
          Institution Directory -
          http://www5.fdic.gov/idasp/advSearchLanding.asp
        </Typography>

        <Typography variant="body2">
          The FDIC Institution Directory (ID) provides the latest comprehensive
          financial and demographic data for every FDIC-insured institution,
          including the most recent quarterly financial statements, with
          performance and condition ratios.
        </Typography>

        <Typography variant="body2">
          Statistics on Depository Institutions:
          http://www5.fdic.gov/sdi/main.asp
        </Typography>

        <Typography variant="body2">
          The FDIC Statistics on Depository Institutions (SDI) is an advanced
          feature of the Institution Directory (ID) that allows you to obtain
          more detailed financial reports. It also provides you with the ability
          to create reports containing customized peer groups of FDIC-insured
          institutions as well as summarize that data at the bank holding
          company level.
        </Typography>

        <Typography variant="body2">
          FDIC.gov {"->"} INDUSTRY ANALYSIS {"->"} Research and Analysis
        </Typography>

        <Typography variant="body2">
          FDIC Quarterly Banking Profile - http://www5.fdic.gov/qbp/index.asp
        </Typography>

        <Typography variant="body2">
          The FDIC Quarterly Banking Profile (QBP) provides the most timely
          comprehensive summary of financial results for all FDIC-insured
          institutions on a quarterly basis. This report card on industry status
          and performance includes written analyses, graphs and statistical
          tables.
        </Typography>

        <Typography variant="body2">
          Statistics on Banking - http://www5.fdic.gov/SDI/SOB/
        </Typography>

        <Typography variant="body2">
          The Statistics on Banking is a quarterly publication that provides
          detailed aggregate financial information as well as key structural
          data (number of institutions and branches) for all FDIC- insured
          institutions.
        </Typography>

        <Typography variant="body2">
          For additional information regarding these publications, please refer
          to the individual web sites or the Bank Data Guide,
          http://www.fdic.gov/bank/statistical/guide/index.html.
        </Typography>

        <Typography variant="h2" id="CONTENTS">
          CONTENTS
        </Typography>
        <Typography variant="body2">
          Commercial Bank Reports and Savings Institution Reports are grouped
          into three categories:
        </Typography>

        <Typography variant="body2">
          Institution and Structure - numbers and types of institutions and
          branches as of year-end
        </Typography>

        <Typography variant="body2">
          Financial Data - Income Statement - year-to-date income and expense
          data
        </Typography>

        <Typography variant="body2">
          Financial Data - Balance Sheet - balance sheet data as of year-end
        </Typography>

        <Typography variant="body2">
          Data Availability - National Aggregates/State Aggregates
        </Typography>
        <Typography variant="body2">
          Commercial Banks 1934 - current 1966 - current
        </Typography>
        <Typography variant="body2">
          Savings Institutions  1984 - current 1984 – current
        </Typography>

        <Typography variant="h2" id="DATA SOURCES">
          DATA SOURCES
        </Typography>
        <Typography variant="body2">
          The structure and financial data sources used in the preparation of
          the publication are:
        </Typography>

        <Typography variant="body2">
          Annual Reports of the Federal Deposit Insurance Corporation, 1934 -
          current
        </Typography>

        <Typography variant="body2">
          Assets and Liabilities, Commercial and Mutual Savings Banks, 1934 -
          1983
        </Typography>

        <Typography variant="body2">
          Bank Operating Statistics, 1968 - 1983
        </Typography>

        <Typography variant="body2">
          FDIC's Research Information System (RIS), 1984 - current
        </Typography>

        <Typography variant="body2">
          The primary sources of financial data for the publications listed
          above are the Reports of Income and Condition submitted by
          FDIC-insured institutions to the Federal commercial bank regulators
          and the Thrift Financial Reports submitted by the FDIC-insured savings
          institutions that were regulated by the Office of Thrift
          Supervision(1984-2011). Structure data are based on information
          contained in the FDIC financial institution structure data base
          (SIMS).
        </Typography>

        <Typography variant="h2" id="METHODOLOGY">
          METHODOLOGY
        </Typography>
        <Typography variant="body2">
          In order to provide the most recent and accurate data, all financial
          data at both the national and state levels from 1984 to the present
          have been obtained from the FDIC's Research Information System (RIS).
          The data in the data base reflects revisions and amendments made
          subsequent to publication in the hard copy sources. All other data has
          been obtained from the other four sources listed above. When using
          published data, both structure and financial values were obtained from
          the latest edition reflecting the data for a particular year. For
          example, the 1965 Annual Report was the source for much of the 1957
          data that appear in the publication. Since not all data, particularly
          at the state level, were revised and republished in later editions of
          the sources, multiple sources for the same year had to be used. The
          effect of using two sources occasionally results in differences in
          aggregate values for the data. These differences are not considered
          significant for the intended use and purpose of the publication
        </Typography>

        <Typography variant="h2" id="COMPARABILITY OF DATA">
          COMPARABILITY OF DATA
        </Typography>
        <Typography variant="body2">
          Reporting requirements and instructions have changed considerably over
          the period covered by this publication. Where possible, adjustments
          have been made to account for these differences to make the values
          adhere as closely as possible to current requirements and
          instructions. The notes accompanying the tables are an integral part
          of the publication and provide information on adjustments made to
          source data and on reporting differences over time.
        </Typography>

        <Typography variant="h2" id="LEVEL OF CONSOLIDATION">
          LEVEL OF CONSOLIDATION
        </Typography>
        <Typography variant="body2">
          All data from 1934 to 1973 represent a consolidation of all domestic
          operations of the institutions and, where available, operations in
          what is designated &quot;Other Areas&quot; in source publications or
          &quot;U.S. Territories&quot; in our interface. These areas are
          represented by Guam, Puerto Rico, Virgin Islands, and all other U.S.
          Territories and possessions. With some exceptions, primarily at the
          state level, all financial data from 1974 to the present represent the
          consolidation of domestic and foreign operations, including operations
          in &quot;Other Areas&quot; or &quot;U.S. Territories&quot;.
        </Typography>

        <Typography variant="h2" id="VALIDATION">
          VALIDATION
        </Typography>
        <Typography variant="body2">
          Every attempt has been made to assure the accuracy and integrity of
          the data contained in the publication. Any inconsistency brought to
          our attention will be investigated and corrected or explained in
          future editions.
        </Typography>

        <Typography variant="h2" id="EXCLUSIONS">
          EXCLUSIONS
        </Typography>
        <Typography variant="body2">
          Data on depository institutions not insured by the FDIC are not
          included in this publication. Institutions in the following categories
          are excluded, although such institutions may perform many of the same
          functions as:
        </Typography>

        <Typography variant="body2">
          FDIC-insured depository institutions
        </Typography>

        <Typography variant="body2">
          State-chartered and private banks not insured by the FDIC
        </Typography>

        <Typography variant="body2">
          FDIC-Insured domestic branches of foreign banks (IBA offices)
        </Typography>

        <Typography variant="body2">Non-deposit trust companies</Typography>

        <Typography variant="body2">
          Other institutions not insured by the FDIC, including credit unions,
          building and loan associations, personal loan companies
        </Typography>

        <Typography variant="body2">
          industrial banks, loan and investment companies, and similar
          institutions, chartered under laws applicable to such institutions or
          under general incorporation laws regardless of whether such
          institutions are called 'banks'
        </Typography>

        <Typography variant="body2">
          Institutions chartered under banking or trust company laws, but
          operating as investment or title insurance companies and not engaged
          in deposit taking
        </Typography>

        <Typography variant="body2">
          Federal Reserve Banks and other banks, such as the Federal Home Loan
          Banks, which operate as rediscount banks and do not accept deposits
          except from financial institutions
        </Typography>

        <Typography variant="body2">
          Branches of FDIC-insured OTS-regulated institutions
        </Typography>

        <Typography variant="h2" id="DEFINITIONS">
          DEFINITIONS
        </Typography>
        <Typography variant="body2">
          Please note that the terms listed below are a partial list of
          definitions that are available. Other definitions are available in the
          Help Index , Institution Directory (ID) and Statistics on Banking
          (SOB) systems.
        </Typography>

        <Typography variant="h3" id="FDIC-Insured Institutions">
          FDIC-Insured Institutions
        </Typography>
        <Typography variant="body2">
          The category of FDIC-insured commercial banks includes all commercial
          banks insured by the Federal Deposit Insurance Corporation (FDIC). It
          also includes all commercial banks insured by the FDIC that are
          regulated by and submit financial data to one of the three Federal
          commercial bank regulators (Board of Governors of the Federal Reserve
          System, Federal Deposit Insurance Corporation or Office of the
          Comptroller of the Currency). The category of FDIC-insured savings
          institutions includes all institutions insured by the FDIC that
          operated under state or federal banking codes applicable to thrift
          institutions. Data on savings institutions that have been placed in
          Resolution Trust Corporation conservatorship (1989 through 1995) are
          not aggregated with other savings institutions, since they do not
          operate as privately-held entities, and their resolution costs do not
          accrue to the FDIC. These RTC conservatorship institutions are listed
          separately as memoranda items where applicable.
        </Typography>

        <Typography variant="h3" id="Charter Class">
          Charter Class
        </Typography>
        <Typography variant="body2">
          The FDIC assigns classification codes indicating an institution's
          charter type (commercial bank, savings bank, or savings association),
          its chartering agent (state or federal government), its Federal
          Reserve membership status (member or nonmember), and its primary
          federal regulator (state-chartered institutions are subject to both
          federal and state supervision). These codes are:
        </Typography>

        <Typography variant="body2">
          N National chartered commercial bank supervised by the Office of the
          Comptroller of the Currency
        </Typography>

        <Typography variant="body2">
          SM State charter Fed member commercial bank supervised by the Federal
          Reserve
        </Typography>

        <Typography variant="body2">
          NM State charter Fed nonmember commercial bank supervised by the FDIC
        </Typography>

        <Typography variant="body2">
          SA State or federal charter savings association supervised by the
          Office of Thrift Supervision or Office of the Comptroller of the
          Currency
        </Typography>

        <Typography variant="body2">
          SB State charter savings bank supervised by the FDIC
        </Typography>

        <Typography variant="h3" id="Charter Type">
          Charter Type
        </Typography>
        <Typography variant="body2">
          A charter is the legal authorization to conduct business and is
          granted to a financial institution by federal or state government.
          Charter types include:
        </Typography>

        <Typography variant="body2">All Charters</Typography>
        <Typography variant="body2">
          Commercial banks, savings institutions and U.S. branches of foreign
          banks insured by the FDIC.
        </Typography>

        <Typography variant="body2">Insured Commercial Banks</Typography>
        <Typography variant="body2">
          Commercial banks insured by the FDIC. These institutions are regulated
          by one of the three Federal commercial bank regulators (FDIC, Federal
          Reserve Board or Office of the Comptroller of the Currency). The
          institutions submit financial reports to the Federal Reserve (state
          member banks), the FDIC (state nonmember banks), or the Office of the
          Comptroller of the Currency (national banks).
        </Typography>

        <Typography variant="body2">Insured Savings Institutions</Typography>
        <Typography variant="body2">
          Savings institutions insured by FDIC that operate under state or
          federal banking codes applicable to thrift institutions.
        </Typography>

        <Typography variant="body2">
          Insured Branches of Foreign Banks
        </Typography>
        <Typography variant="body2">
          Branches of foreign banks (banks chartered and headquartered outside
          the U.S.) that are insured by the FDIC. These institutions are
          regulated by one of the three Federal commercial bank regulators and
          submit financial data to the Federal Reserve.
        </Typography>

        <Typography variant="h3" id="Effective Date">
          Effective Date
        </Typography>
        <Typography variant="body2">
          The date that the failed / assisted institution ceased to exist as a
          privately held going concern. For institutions that entered into
          government ownership, such as FDIC Bridge Banks and RTC
          conservatorships, this is the date that they entered into such
          ownership.
        </Typography>

        <Typography variant="h3" id="FDIC-Insured Commercial Banks">
          FDIC-Insured Commercial Banks
        </Typography>
        <Typography variant="body2">
          Includes all commercial banks insured by the FDIC. These institutions
          are regulated by and submit financial data to one of three federal
          commercial bank regulators (the Federal Reserve Board, the FDIC, or
          the Office of the Comptroller of the Currency). FDIC-insured
          commercial banks include the following categories of depository
          institutions insured by the FDIC:
        </Typography>

        <Typography variant="body2">National banks</Typography>
        <Typography variant="body2">
          State-chartered banks and trust companies, except savings banks
        </Typography>

        <Typography variant="body2">
          Commercial banks, either nationally or state-chartered, insured by the
          FDIC
        </Typography>

        <Typography variant="body2">
          Other financial institutions which operate under general banking
          codes, or are specifically authorized by law to accept deposits and in
          practice do so or the obligations of which are regarded as deposits
          for deposit insurance
        </Typography>

        <Typography variant="h3" id="FDIC-Insured Savings Institutions">
          FDIC-Insured Savings Institutions
        </Typography>
        <Typography variant="body2">
          Includes all institutions insured by either the FDIC operating under
          state or federal banking codes applicable to savings institutions.
          Data on savings institutions that have been placed in RTC
          conservatorship are not aggregated with those that were not, since the
          former do not operate as privately-held entities, and their resolution
          costs do not accrue to the FDIC. These RTC conservatorships are listed
          separately as memoranda, where applicable.
        </Typography>

        <Typography variant="h3" id="Cert">
          Cert
        </Typography>
        <Typography variant="body2">
          The certificate number assigned by the FDIC used to identify
          institutions and for the issuance of insurance certificates. By
          clicking on this number, you will link to the Institution Directory
          (ID) system which will provide the last demographic and financial data
          filed by the selected institution.
        </Typography>

        <Typography variant="h3" id="Failure/Assistance">
          Failure/Assistance
        </Typography>
        <Typography variant="body2">
          The given institution has failure stature or it can be assistance has
          been provided by FDIC in merging with other institution.
        </Typography>

        <Typography variant="h3" id="Estimated Loss">
          Estimated Loss
        </Typography>
        <Typography variant="body2">
          The estimated loss is the difference between the amount disbursed from
          the Deposit Insurance Fund (DIF) to cover obligations to insured
          depositors and the amount estimated to be ultimately recovered from
          the liquidation of the receivership estate. Estimated losses reflect
          unpaid principal amounts deemed unrecoverable and do not reflect
          interest that may be due on the DIF's administrative or subrogated
          claims should its principal be repaid in full.
        </Typography>

        <Typography variant="body2">Notes:</Typography>
        <Typography variant="body2">
          Comprehensive data on estimated losses are not available for
          FDIC-insured failures prior to 1986, or for FSLIC-insured failures
          from 1934-88. Estimated loss is presented as &quot;N/A&quot; in years
          for which comprehensive information is not available.
        </Typography>

        <Typography variant="body2">
          Estimated Loss data was previously referred to as 'Estimated Cost' in
          past releases of the Historical Statistic on Banking. For RTC
          receiverships, the 'Estimated Cost' included an allocation of FDIC
          corporate revenue and expense items such as interest expense on
          Federal Financing Bank debt, interest expense on escrowed funds and
          interest revenue on advances to receiverships. Other FDIC
          receiverships did not include such an allocation. To maintain
          consistency with FDIC receiverships, the RTC allocation is no longer
          reflected in the estimated loss amounts for failed / assisted
          institutions that were resolved through RTC receiverships.
        </Typography>

        <Typography variant="body2">
          Beginning with the release of 2007 information, the 'Estimated Loss'
          in the Historical Statistics on Banking is presented and defined
          consistently with the aggregate Estimated Receivership Loss for
          FRF-RTC institutions and Estimated Losses for FDIC receiverships that
          are reported in the FDIC's Annual Report. The estimated loss is
          obtained from the FDIC's Failed Bank Cost Analysis (FBCA) report and
          the RTC Loss report. The FBCA provides data for receiverships back to
          1986. The RTC Loss Report provides similar data back to 1989.
        </Typography>

        <Typography variant="body2">
          Questions regarding Estimated Loss should be sent to
          DOFBusinessCenter@fdic.gov.
        </Typography>

        <Typography variant="body2">
          Also, for more detail regarding resolution transactions and the FDIC's
          receivership activities, see Managing the Crisis: The FDIC and RTC
          Experience, a historical study prepared by the FDIC's Division of
          Resolutions and Receiverships. Copies are available from the FDIC's
          Public Information Center.
        </Typography>

        <Typography variant="body2">Insurance Fund</Typography>
        <Typography variant="body2">
          Before 1989, there were two federal deposit insurance funds, one
          administered by the FDIC, which insured deposits in commercial banks
          and state-chartered savings banks, and another administered by the
          Federal Savings and Loan Insurance Corporation (FSLIC), which insured
          deposits in state- and federally-chartered savings associations. In
          1989, the Financial Institutions Reform, Recovery and Enforcement Act
          (FIRREA) specified that thereafter the FDIC would be the federal
          deposit insurer of all banks and savings associations and would
          administer both the FDIC fund, which was renamed the Bank Insurance
          Fund (BIF) and the replacement for the insolvent FSLIC fund, which was
          called the Savings Association Insurance Fund (SAIF). Although it was
          created in 1989, the SAIF was not responsible for savings association
          failures until 1996. From 1989 through 1995, savings association
          failures were the responsibility of the Resolution Trust Corporation
          (RTC). In February 2006, The Federal Deposit Insurance Reform Act of
          2005 provided for the merger of the BIF and the SAIF into a single
          Deposit Insurance Fund (DIF). Necessary technical and conforming
          changes to the law were made under The Federal Deposit Insurance
          Reform Conforming Amendments Act of 2005. The merger of the funds was
          effective on March 31, 2006.
        </Typography>

        <Typography variant="body2">
          For additional information about deposit insurance fund and
          legislation, go to http://www.fdic.gov/deposit/insurance/index.html.
        </Typography>

        <Typography variant="body2">FIN</Typography>
        <Typography variant="body2">
          Financial Institution Number is a unique number assigned to the
          institution as an Assistance Agreement, Conservatorship, Bridge Bank
          or Receivership.
        </Typography>

        <Typography variant="body2">State</Typography>
        <Typography variant="body2">
          The state in which the headquarters of the institution are physically
          located. The FDIC Act defines state as any State of the United States,
          the District of Columbia, and any territory of the United States,
          Puerto Rico, Guam, American Samoa, the Trust Territory of the Pacific
          Islands, the Virgin Island, and the Northern Mariana Islands.
        </Typography>

        <Typography variant="body2">
          You can select one of the three summary levels or individual states,
          but not both. For the Bank Failures and Assistance Transaction report
          you can select multiple states by holding down the Control Key and
          selecting specific states.
        </Typography>

        <Typography variant="body2">Location</Typography>
        <Typography variant="body2">
          The city and state (or territory) of the headquarters of the
          institution.
        </Typography>

        <Typography variant="body2">Institution Name</Typography>
        <Typography variant="body2">
          This is the legal name of the institution. When available, the
          Institution's name links to useful information for the customers and
          vendors of these institutions. This information includes press
          releases, information about the acquiring institution, (if
          applicable), how your accounts and loans are affected, and how vendors
          can file claims against the receivership.
        </Typography>

        <Typography variant="body2">Total Assets</Typography>
        <Typography variant="body2">
          The Total assets owned by the institution including cash, loans,
          securities, bank premises and other assets as of the last Call Report
          or Thrift Financial Report filed by the institution prior to the
          effective date. Note this does not necessarily reflect total assets on
          the last report filed because in some cases reports were filed after
          the effective date. This total does not include off-balance-sheet
          accounts.
        </Typography>

        <Typography variant="body2">Total Deposits</Typography>
        <Typography variant="body2">
          Total including demand deposits, money market deposits, other savings
          deposits, time deposits and deposits in foreign offices as of the last
          Call Report or Thrift Financial Report filed by the institution prior
          to the effective date. Note this does not necessarily reflect total
          deposits on the last report filed because in some cases reports were
          filed after the effective date.
        </Typography>

        <Typography variant="body2">Transaction Types</Typography>
        <Typography variant="body2">
          Institutions have been resolved through several different types of
          transactions. The transaction types outlined below can be grouped into
          three general categories, based upon the method employed to protect
          insured depositors and how each transaction affects a failed /
          assisted institution's charter. In most assistance transactions,
          insured and uninsured depositors are protected, the failed / assisted
          institution remains open and its charter survives the resolution
          process. In purchase and assumption transactions, the failed /
          assisted institution's insured deposits are transferred to a successor
          institution, and its charter is closed. In most of these transactions,
          additional liabilities and assets are also transferred to the
          successor institution. In payoff transactions, the deposit insurer -
          the FDIC or the former Federal Savings and Loan Insurance Corporation
          - pays insured depositors, the failed / assisted institution's charter
          is closed, and there is no successor institution. For a more complete
          description of resolution transactions and the FDIC's receivership
          activities, see Managing the Crisis: The FDIC and RTC Experience, a
          study prepared by the FDIC's Division of Resolutions and
          Receiverships. Copies are available from the FDIC's Public Information
          Center.
        </Typography>

        <Typography variant="body2">
          Category 1 - Institution's charter survives
        </Typography>
        <Typography variant="body2">
           A/A - Assistance Transactions. These include:
        </Typography>

        <Typography variant="body2">
          1) transactions where assistance was provided to the acquirer, who
          purchased the entire institution. For a few FSLIC transactions, the
          acquirer purchased the entire bridge bank - type entity, but certain
          other assets were moved into a liquidating receivership prior to the
          sale, and
        </Typography>

        <Typography variant="body2">
          2) open bank assistance transactions, including those where assistance
          was provided under a systemic risk determination (in such cases any
          costs that exceed the amounts estimated under the least cost
          resolution requirement would be recovered through a special assessment
          on all FDIC-insured institutions).
        </Typography>

        <Typography variant="body2">
           REP - Reprivatization, management takeover with or without assistance
          at takeover, followed by a sale with or without additional assistance.
        </Typography>

        <Typography variant="body2">Category 2</Typography>
        <Typography variant="body2">
          Institution's charter is terminated, insured deposits plus some assets
          and other liabilities are transferred to a successor charter
        </Typography>

        <Typography variant="body2">
          P&amp;A - Purchase and Assumption, where some or all of the deposits,
          certain other liabilities and a portion of the assets (sometimes all
          of the assets) were sold to an acquirer. It was not determined if all
          of the deposits (PA) or only the insured deposits (PI) were assumed.
        </Typography>

        <Typography variant="body2">
           PA - Purchase and Assumption, where the insured and uninsured
          deposits, certain other liabilities and a portion of the assets were
          sold to an acquirer.
        </Typography>

        <Typography variant="body2">
           PI - Purchase and Assumption of the insured deposits only, where the
          traditional P&amp;A was modified so that only the insured deposits
          were assumed by the acquiring institution.
        </Typography>

        <Typography variant="body2">
          IDT - Insured Deposit Transfer, where the acquiring institution served
          as a paying agent for the insurer, established accounts on their books
          for depositors, and often acquired some assets as well. Includes ABT
          (asset-backed transfer, a FSLIC transaction that is very similar to an
          IDT).
        </Typography>

        <Typography variant="body2">
          MGR - An institution where FSLIC took over management and generally
          provided financial assistance. FSLIC closed down before the
          institution was sold.
        </Typography>

        <Typography variant="body2">Category 3</Typography>
        <Typography variant="body2">
          PO - Payout, where the insurer paid the depositors directly and placed
          the assets in a liquidating receivership.
        </Typography>

        <Typography variant="body2">
          Note: Includes transactions where the FDIC established a Deposit
          Insurance National Bank to facilitate the payout process.
        </Typography>

        <Typography variant="h2" id="COMMENTS, SUGGESTIONS AND REQUESTS">
          COMMENTS, SUGGESTIONS AND REQUESTS
        </Typography>

        <Typography variant="body2">
          Comments and content suggestions for the Historical Statistics on
          Banking should be sent to:
        </Typography>

        <Typography variant="body2">
          http://www5.fdic.gov/idasp/DIRSInfoRequest.asp.
        </Typography>

        <Typography variant="h1" id="DATA AVAILABILITY">
          DATA AVAILABILITY
        </Typography>

        <Typography variant="body2">
          Historical Statistics on Banking (HSOB) provides annual statistical
          information on the banking industry beginning in 1934. These data can
          be used to identify and analyze long-term trends and to develop
          benchmarks to evaluate the current condition of the banking and thrift
          industries.
        </Typography>

        <Typography variant="body2">
          The HSOB contains aggregated data from individual financial reports
          filed by FDIC-insured commercial banks and savings institutions. These
          aggregated data are also available for individual states, U.S.
          territories and U.S. possessions. For the most current quarterly
          aggregate data, please refer to the Statistics on Depository
          Institutions (SDI).
        </Typography>

        <Typography variant="body2">
          FDIC provides financial and structural data about individual
          institutions in the Institution Directory (ID).
        </Typography>

        <Typography
          variant="h2"
          id="Number of Institutions by Regulatory Agent and Insurance Fund"
        >
          Number of Institutions by Regulatory Agent and Insurance Fund
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Deposit Insurance Fund (DIF),the
          Bank Insurance Fund (BIF) or the Savings Association Insurance Fund
          (SAIF) that operated under state or federal banking codes applicable
          to thrift institutions, except for one self-liquidating institution
          primarily funded by the FSLIC Resolution Fund (FRF). Savings
          institutions that were placed in Resolution Trust Corporation
          conservatorship are excluded from these tables while in
          conservatorship. For relevant dates of operation of agencies and
          insurance funds see &quot;Significant Events&quot; below. The
          institutions covered in this section were regulated by and submit
          financial reports to the Federal Deposit Insurance Corporation (FDIC),
          the Federal Savings and Loan Insurance Corporation (FSLIC),the Office
          of Thrift Supervision (OTS) or the Office of the Comptroller of the
          Currency (OCC).Data for the savings institutions regulated by the FDIC
          are from the Federal Financial Institution Examination Council (FFIEC)
          Reports of Income and Condition submitted to the FDIC (Call Reports).
          Data for savings institutions regulated by the Office of Thrift
          Supervision (OTS) are from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the Thrift Financial Reports to provide closer conformance
          with the reporting and accounting requirements of the Call Reports.
          These notes are an integral part of this publication and provide
          information regarding the comparability of source data and reporting
          differences over time.
        </Typography>

        <Typography variant="body2">Significant Events</Typography>

        <Typography variant="body2">
          1984 -- Deposit insurance for mutual savings banks (savings banks with
          no capital stock that accept only, with a few exceptions, savings
          deposits and whose earnings inure to the benefit of the depositor).
          These banks include those operating under special state banking codes
          applicable to mutual savings banks and all guaranty savings banks in
          New Hampshire and all insured savings banks in Massachusetts.Although
          HSOB data are available only from 1984, such institutions were insured
          by the FDIC before that date.
        </Typography>

        <Typography variant="body2">
          Deposit insurance for all savings and loan associations and all
          federally insured savings banks not insured by the FDIC provided by
          the Federal Savings and Loan Insurance Corporation (FSLIC).Although
          HSOB data are available only from 1984, such institutions were insured
          by the FSLIC before that date.
        </Typography>

        <Typography variant="body2">
          1989 -- Financial Institutions Reform, Recovery, and Enforcement Act
          (FIRREA) was signed into law on August 9, 1989. FIRREA also created
          and funded a government agency, the Resolution Trust Corporation (RTC)
          to manage and dispose of, either through sale or liquidation, any
          failed savings institution transferred from the OTS through September
          30, 1993. FIRREA specified that any funds needed to protect the
          depositors of these failed savings institutions would be publicly
          provided until the termination of the RTC on December 31, 1996.
          Additionally, FIRREA specified that the FDIC would be the sole insurer
          of all financial institutions, and that institutions would acquire
          deposit insurance through either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) depending upon their
          charter. The SAIF replaced the FSLIC insurance fund. Further, FIRREA
          specified that any acquisition of deposits insured by a fund other
          than the acquiring institution's must maintain a percentage in both
          insurance funds equivalent to the membership percentage at the date of
          acquisition. Regulatory supervision continued to be provided by the
          FDIC and the OTS depending upon the charter of the institution.
        </Typography>

        <Typography variant="body2">
          1993 -- The RTC Completion Act extends the RTC's responsibility to
          accept failed savings institutions from OTS through July 1, 1995 and
          terminates the RTC on December 31, 1995. Funding for future failures
          of savings institutions to be borne by either the BIF or SAIF.
        </Typography>

        <Typography variant="body2">
          1996 -- The Deposit Insurance Fund Act of 1996 (DIFA) was passed at
          the end of the third quarter and included a one-time special
          assessment on institutions with SAIF insurance that cost the industry
          $3.5 billion. The DIFA was part of the Economic Growth and Regulatory
          Paper Reduction Act of 1996. This act relaxed the Qualified Thrift
          Lender test by increasing the amount of consumer-oriented loans, such
          as credit card loans, that can be counted as qualifying assets. This
          act also raised the allowable percentage of loans to commercial
          borrowers to 20 percent, where amounts in excess of 10 percent must be
          made up of loans to small businesses. Earlier in the year, the Small
          Business Job Protection Act of 1996 removed the favorable treatment
          for a bad debt reserve for tax purposes. This act put savings
          institutions on par with commercial banks for the tax treatment of bad
          debt reserves. Starting in 1996, the TFR was completed on a fully
          consolidated basis, with the exception of subsidiary depository
          institutions being reported on the equity method of accounting. The
          Call reports also use this method of consolidation. Prior to this
          time, the TFR reflected the consolidation of the parent thrift with
          all finance subsidiaries only. All other subsidiaries were reported on
          an equity or cost basis.
        </Typography>

        <Typography variant="body2">
          2006 -- Among its provisions, the Federal Deposit Insurance Reform Act
          of 2005 merged the Bank Insurance Fund (BIF) and the Savings
          Association Insurance Fund (SAIF) into a new fund, the Deposit
          Insurance Fund (DIF). This change was made effective March 31, 2006.
        </Typography>

        <Typography variant="body2">
          2010 -- The Dodd-Frank Wall Street Reform and Consumer Protection Act
          of 2010 was signed into law on July 21, 2010. Effective one year after
          enactment, this legislation transferred supervisory authority over
          OTS-supervised, federally chartered savings institutions to the OCC
          and over OTS-supervised, state-chartered savings institutions to the
          FDIC. The legislation also provided for the abolition of the OTS 90
          days after the transfer date and the assumption of its duties by the
          OCC.
        </Typography>

        <Typography variant="body2">
          {" "}
          Number of Institutions by Regulatory Agent and Insurance Fund
          FDIC-Insured Savings Institutions All States and Territories
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          FDIC supervised, SAIF insured Institutions – institutions supervised
          by FDIC and included in the Savings Association Insurance Fund{" "}
        </Typography>

        <Typography variant="body2">
          FDIC Supervised, BIF Insured Institutions - institutions supervised by
          FDIC and included in the Bank Insurance Fund{" "}
        </Typography>

        <Typography variant="body2">
          Total FDIC Supervised Savings Institutions – The number of FDIC
          supervised savings institutions filing a 12/31 financial report.
        </Typography>

        <Typography variant="body2">
          Non FDIC supervised SAIF Insured Institutions – The number of Savings
          institutions insured by the Savings Institutions Insurance Fund that
          are not FDIC supervised.
        </Typography>

        <Typography variant="body2">
          Non FDIC Supervised BIF Insured Institutions - The number of Savings
          institutions insured by the Bank Insurance Fund that are not FDIC
          supervised.
        </Typography>
        <Typography variant="body2">
          Total Non FDIC Supervised Savings Institutions – all non FDIC
          supervised Savings Institutions
        </Typography>
        <Typography variant="body2">
          Total Savings Institutions – Total Number of Savings Institutions{" "}
        </Typography>

        <Typography variant="body2">
          RTC Conservatorships - Represents institutions that were declared
          failed and placed under RTC conservatorship until a buyer(s) is(are)
          found or a payout to depositors occurs{" "}
        </Typography>

        <Typography variant="h2" id="Changes in Number of Institutions">
          Changes in Number of Institutions
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">Additions During Year:</Typography>
        <Typography variant="body2">
          New Institutions Chartered -- Represents institutions newly chartered
          by federal or state banking authorities including authorities in the
          U. S. Territories or possessions.
        </Typography>

        <Typography variant="body2">
          New Charter To Absorb Another Charter -- Represents a new savings
          institution charter created to absorb any other type of charter in its
          first quarter of operation.
        </Typography>

        <Typography variant="body2">
          Noninsured Becoming Insured -- Represents the transfer of an existing
          institution that does not have deposit insurance to a savings
          institution charter with FDIC insurance from BIF or SAIF. Examples of
          such institutions include Trust Banks and savings institutions with
          state deposit insurance that apply for and receive FDIC insurance.
        </Typography>

        <Typography variant="body2">
          Charter Transfers From Commercial Banks -- Represents the transfer of
          a commercial bank to a savings institution charter that meets the
          definition of a thrift and has applied for and received FDIC insurance
          (BIF or SAIF).
        </Typography>

        <Typography variant="body2">Deletions During Year</Typography>
        <Typography variant="body2">
          Unassisted Mergers and Consolidations of Thrifts -- Represents the
          absorption of a savings institution charter by another savings
          institution without assistance. Both institutions may be owned by the
          same holding company in a consolidation of affiliates.
        </Typography>

        <Typography variant="body2">
          Unassisted Mergers With Commercial Banks -- Represents the absorption
          of a savings institution charter by a commercial bank without
          assistance.
        </Typography>

        <Typography variant="body2">Closings</Typography>
        <Typography variant="body2">
          Assisted Mergers of Thrifts -- Represents the absorption of a failing
          savings institution by another savings institution with assistance
          from either the BIF or SAIF. (Included are RTC Accelerated Resolution
          Program (ARP) assisted mergers. These institutions were not placed in
          RTC conservatorship.)
        </Typography>

        <Typography variant="body2">
          Assisted Mergers with Commercial Banks
        </Typography>
        <Typography variant="body2">
          Assisted Payouts -- Represents all assisted payouts of FDIC-insured
          savings institutions that are not in RTC conservatorship.
        </Typography>

        <Typography variant="body2">
          Voluntary Liquidations -- Represents all instances where the owners of
          a thrift voluntarily surrender their charter with all liabilities
          including deposits paid down and all assets sold.
        </Typography>

        <Typography variant="body2">
          Failures Transferred To RTC Conservatorship -- Represents institutions
          that were declared failed and placed under RTC conservatorship until a
          buyer(s) is(are) found or a payout to depositors occurs.
        </Typography>

        <Typography variant="body2">
          Charter Transfers To Commercial Banks -- Represents the charter
          transfer of existing FDIC-insured savings institutions to an
          FDIC-insured commercial bank charter.
        </Typography>

        <Typography variant="body2">
          Other Misc. Adjustments - Adjustment For Missing Reports -- Represents
          any FDIC-insured savings institution that did not file a financial
          report during the year in which the charter was added or deleted.
        </Typography>

        <Typography variant="body2">
          Total Savings Institutions at year End – Includes all FDIC-Insured
          savings institutions that did or did not file a 12/31 financial report
          plus other adjustments.
        </Typography>

        <Typography variant="h2" id="Net Income">
          Net Income
        </Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">Significant Events</Typography>

        <Typography variant="body2">
          1984 -- Deposit insurance for mutual savings banks (savings banks with
          no capital stock that accept only, with a few exceptions, savings
          deposits and whose earnings inure to the benefit of the depositor).
          These banks include those operating under special state banking codes
          applicable to mutual savings banks and all guaranty savings banks in
          New Hampshire and all insured savings banks in Massachusetts.
        </Typography>

        <Typography variant="body2">
          1984 -- Deposit insurance for all savings and loan associations and
          all federally insured savings banks not insured by the FDIC provided
          by the Federal Savings and Loan Insurance Corporation (FSLIC).
        </Typography>

        <Typography variant="body2">
          1989 -- Financial Institutions Reform, Recovery, and Enforcement Act
          (FIRREA) passed. FIRREA created and funded a government agency, the
          Resolution Trust Corporation (RTC) to manage and dispose of, either
          through sale or liquidation, any failed savings institution
          transferred from OTS through September 30, 1993. FIRREA specified that
          any funds needed to protect the depositors of these failed savings
          institutions would be publicly provided until the termination of the
          RTC on December 31, 1996. Additionally, FIRREA specified that the FDIC
          would be the sole insurer of all financial institutions, and that
          institutions would acquire deposit insurance through either the Bank
          Insurance Fund (BIF) or the Savings Association Insurance Fund (SAIF)
          depending upon their charter. The SAIF replaced the FSLIC insurance
          fund. Further, FIRREA specified that any acquisition of deposits
          insured by a fund other than the acquiring institution's must maintain
          a percentage in both insurance funds equivalent to the membership
          percentage at the date of acquisition. Regulatory supervision
          continued to be provided by the FDIC and the OTS depending upon the
          charter of the institution.
        </Typography>

        <Typography variant="body2">
          1993-present -- The RTC Completion Act extends the RTC's
          responsibility to accept failed savings institutions from OTS through
          July 1, 1995 and terminates the RTC on December 31, 1995. Funding for
          future failures of savings institutions to be borne by either the BIF
          or SAIF.
        </Typography>

        <Typography variant="body2">Field Content</Typography>
        <Typography variant="body2">
          Total Savings Institutions - The total number of FDIC-Insured savings
          institutions submitting Call reports or Thrift Financial Reports. This
          number may differ from the actual count of institutions in other
          tables due to the exclusion of institutions active on December 31 that
          did not submit a Call report. This occurs most often when an
          institution is merged or closed on or just after December 31. This
          number does not include any institution transferred to the RTC.
        </Typography>

        <Typography variant="body2">
          Total Interest Income -- Represents total interest income earned or
          accrued on all assets.
        </Typography>

        <Typography variant="body2">
          Total Interest Expense -- Represents total interest paid or accrued on
          all interest-bearing liabilities.
        </Typography>

        <Typography variant="body2">
          Net Interest Income -- Represents the difference between Total
          Interest Income and Total Interest Expense.
        </Typography>

        <Typography variant="body2">
          Total Noninterest Income -- Represents the total of all noninterest
          income.
        </Typography>

        <Typography variant="body2">
          Total Noninterest Expense -- Represents the total of all noninterest
          expense.
        </Typography>

        <Typography variant="body2">
          -- 1984-1986 -- Includes losses on sale of mortgage pool and other
          securities held for investment for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1987-1989 -- For TFR filers, excludes losses on loans held for
          investment.
        </Typography>

        <Typography variant="body2">
          Provision for Loan and Lease Losses
        </Typography>
        <Typography variant="body2">
          -- 1984-1986 -- This item is not reported for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1987-present -- Represents the amount needed to make the allowance
          for loan and lease losses adequate to absorb expected loan and lease
          losses, based upon management's evaluation of the bank's current loan
          and lease portfolio. The amount taken here may differ from the bad
          debt expense deduction taken for federal income tax purposes.
        </Typography>

        <Typography variant="body2">
          Pre-tax Net Operating Income -- Represents Net Interest Income plus
          Total Noninterest Income less Total Noninterest Expense and the
          Provision for Loan &amp; Lease Losses
        </Typography>

        <Typography variant="body2">Securities Gains and (Losses)</Typography>

        <Typography variant="body2">
          -- 1984-1986 -- TFR filers report only gains. Losses on securities
          included in Noninterest Expense.
        </Typography>

        <Typography variant="body2">
          -- 1987-1989 -- Includes gains (losses) on loans held for investment
          for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents the net value of profits on securities
          sold or redeemed less losses on securities sold. Actual recoveries on
          securities and actual charge-offs are reported separately and are
          included in
        </Typography>

        <Typography variant="body2">
          Noninterest Income - All Other or Noninterest Expense - All Other,
          respectively.
        </Typography>

        <Typography variant="body2">
          Applicable Income Taxes -- Represents Federal, state and local taxes
          on income. It does not include taxes relating to securities
          transactions or extraordinary items.
        </Typography>

        <Typography variant="body2">
          Net Extraordinary Items -- Represents the results of material events
          and transactions that are both unusual and infrequent.
        </Typography>

        <Typography variant="body2">
          Net Income -- Represents the net result of all income less all
          expenses. Beginning in June 2009, Net Income (Loss) does not include
          Non-Controlling Interest. Net Income Attributable to Non Controlling
          Interest (NETIMIN) and Net Income - Bank and Non-Controlling Interests
          (NETINBM) are not included in table SI07.
        </Typography>

        <Typography variant="h2" id="Interest Income">
          Interest Income
        </Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          Interest Income on Loans -- Represents all interest, fees and similar
          charges levied against or associated with all assets reportable as
          loans. Includes interest, yield related fees, commitment fees, service
          charges on loans and discount accretion.
        </Typography>

        <Typography variant="body2">
          (One savings bank with an office in Canada has been reporting on the
          Domestic &amp; Foreign Consolidated Call report form (FFIEC 031). It
          does not, however, indicate any income or expenses relating to foreign
          operations).
        </Typography>

        <Typography variant="body2">
          Interest Income on Leases -- 1984-1988 -- Income on leases, if any, is
          included in interest income on loans.
        </Typography>

        <Typography variant="body2">
          -- 1989-present -- Represents income and fees relating to direct
          financing and leveraged leases.
        </Typography>

        <Typography variant="body2">
          Interest Income on Loans and Leases -- Total -- Represents the total
          of income on loans and income on leases.
        </Typography>

        <Typography variant="body2">Interest Income on Securities</Typography>

        <Typography variant="body2">
          -- 1984 - 1989 -- Represents interest and dividends, net of premium
          amortization and discount of accretion, on all assets that are
          reportable as securities. Includes interest income on assets held in
          trading accounts for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents interest and dividends, net of premium
          amortization and discount of accretion, on all assets that are
          reportable as securities.
        </Typography>

        <Typography variant="body2">
          This item includes interest income on deposits for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 2001-present - Includes Other Interest Income.
        </Typography>

        <Typography variant="body2">
          Interest Income on Trading Account Assets
        </Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Represents interest income earned on all trading
          account assets. This item is included in Securities for TFR filers. It
          was not separately reported.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents interest income earned on all trading
          account assets.
        </Typography>

        <Typography variant="body2">
          Interest Income on Federal Funds Sold &amp; Securities Purchased –
          Represents gross income of all assets reportable under this category.
          This item is included in Securities for TFR filers. It was not
          separately reported.
        </Typography>

        <Typography variant="body2">
          Interest Income on Balances Due From Depository Institutions
        </Typography>
        <Typography variant="body2">
          -- 1984-1985 -- This value was reported as part of other operating
          income and is included in Noninterest Income - All Other.
        </Typography>

        <Typography variant="body2">
          -- 1986-present -- Represents income from balances due from other
          depository institutions.
        </Typography>

        <Typography variant="body2">
          This item is not separately reported by TFR filers. It is included in
          Securities.
        </Typography>

        <Typography variant="body2">
          Total Other Interest Income -- Represents the total of all Other
          Interest Income components.
        </Typography>

        <Typography variant="body2">Total Interest Income</Typography>
        <Typography variant="body2">
          -- 1984-present -- Represents the sum of Interest Income on Loans and
          Leases - Total plus Other Interest Income- Total.
        </Typography>

        <Typography variant="h2" id="Interest Expense">
          Interest Expense
        </Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">Total Deposit Interest Expense</Typography>
        <Typography variant="body2">
          -- 1984-present -- Represents all interest on all liabilities
          reportable as deposits. Includes finders' and brokers' fees that
          represent an adjustment to the interest paid on deposits acquired
          through brokers. Early withdrawal penalties or portions of such
          penalties that represent the forfeiture of interest are deducted from
          gross interest paid.
        </Typography>

        <Typography variant="body2">
          (One savings bank with an office in Canada has been reporting on the
          Domestic and Foreign Consolidated Call report form (FFIEC 031). It
          does not, however, indicate any income or expense relating to foreign
          operations).
        </Typography>

        <Typography variant="body2">
          Interest Expense Other - Federal Funds Purchased and Securities Sold
          -- Represents the gross expense of all liabilities reportable under
          this category.
        </Typography>

        <Typography variant="body2">
          This item is not reported separately by TFR filers. It is included in
          Borrowed Money.
        </Typography>

        <Typography variant="body2">
          Interest Expense Other - Borrowed Money -- Represents interest expense
          related to demand notes issued to the U.S. Treasury, mortgage
          indebtedness, obligations under capitalized leases and on other
          borrowed money.
        </Typography>

        <Typography variant="body2">
          Interest Expense - Subordinated Notes &amp; Debentures -- Represents
          interest expense related to subordinated notes, capital notes, and
          debentures.
        </Typography>

        <Typography variant="body2">
          Interest Expense Other - Advances from FHLBank -- Represents interest
          expense and yield adjustments on all advances from the FHLBank.
        </Typography>

        <Typography variant="body2">
          This item is not reported by FDIC Call Report filers.
        </Typography>

        <Typography variant="body2">
          Total Other Interest Expense -- Represents the sum of all components
          of Other Interest Expense.
        </Typography>

        <Typography variant="body2">
          Total Interest Expense -- Represents the total of Interest on Deposits
          plus Other Interest Expense - Total.
        </Typography>

        <Typography
          variant="h2"
          id="Noninterest Income and Noninterest Expense"
        >
          Noninterest Income and Noninterest Expense
        </Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          Fee Income- Non-interest Income - Represents service charges on
          deposit accounts such as maintenance fees, activity charges,
          administrative charges, overdraft charges and check certification
          charges; mortgage loan servicing fees plus other fees and charges,
          including prepayment loan fees, late charges, assumption fees, and
          amortization of commitment fees.
        </Typography>

        <Typography variant="body2">Other Noninterest Income</Typography>
        <Typography variant="body2">
          -- 1984 - 1989 -- Same as above except gains on the sale of loans held
          for investment are excluded for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1990 - Present -- Represents income derived from the sale of assets
          held for sale; office building operations; real estate held for
          investment; REO operations; LOCOM adjustments made to assets held for
          sale; net income (loss) from investments in service
          corporations/subsidiaries (other than operating or finance
          subsidiaries); leasing operations; realized and unrealized gains
          (losses) on trading assets; gains on the sale of REO real estate held
          for investment, and loans held for investment; and the amortization of
          deferred gains (losses) on asset hedges.
        </Typography>

        <Typography variant="body2">Total Non Interest Income</Typography>
        <Typography variant="body2">
          -- 1984 - 1989 -- Represents the sum of Other Fee Income plus All
          Other. Excludes gains on the sale of loans held for investments for
          TFR filers which are included in securities gains.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents the sum of Other Fee Income plus All
          Other.
        </Typography>

        <Typography variant="body2">
          {" "}
          Employee Salaries &amp; Benefits - Noninterest Expense --{" "}
        </Typography>
        <Typography variant="body2">
          -- Represents salaries, taxes and benefits of all officers and
          employees of the bank and its consolidated subsidiaries including
          guards, temporary office help, cafeteria employees, and building and
          maintenance employees.
        </Typography>

        <Typography variant="body2">
          Occupancy Expenses -- Represents all noninterest expenses related to
          the use of the premises, equipment, furniture and fixtures of the
          institution, whether owned or leased, net of any rental income
          received.
        </Typography>

        <Typography variant="body2">All Other Non-Interest Expenses</Typography>
        <Typography variant="body2">
          -- 1984 - 1986 -- Same as above except that it includes loss on sale
          of securities held for investments for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1987-present -- Represents amounts of all other categories of
          expense not included elsewhere. Includes fees paid to directors,
          trustees and advisory board members; premiums on fidelity insurance
          and deposit insurance; retainer and legal fees; net losses from the
          sale or disposition of loans, premises and fixed assets, other real
          estate owned, and branches; management fees assessed by parent bank
          holding companies; advertising, public relations and promotional
          expenses; amortization expense of intangible assets; charitable
          contributions; net losses on futures and forward contracts; office
          supplies; telephone expenses; examination and audit fees; charge-offs
          and write downs of securities prior to sale; and other miscellaneous
          expenses.
        </Typography>

        <Typography variant="body2">
          -- 2001-present -- includes amortization and impaired loss for other
          intangible assets (EAMINTAN).
        </Typography>

        <Typography variant="body2">
          Total Non Interest Expense --Represents the sum of all noninterest
          expense components.
        </Typography>

        <Typography variant="body2">
          Memo: Amortization of Intangibles -- Represents the amortization
          expense of intangible assets, primarily goodwill. Includes only
          amortization of goodwill for TFR filers.
        </Typography>

        <Typography
          variant="h2"
          id="Charge-Offs and Recoveries on Loans/Leases, Cash Dividends and Number of Employees"
        >
          Charge-Offs and Recoveries on Loans/Leases, Cash Dividends and Number
          of Employees
        </Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">Loan and Lease Charge-offs</Typography>

        <Typography variant="body2">
          -- 1984-1989 -- Represents actual loans and leases charged off against
          the allowance for loan and lease losses. Not collected by TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents actual loans and leases charged off
          against the allowance for loan and lease losses.
        </Typography>

        <Typography variant="body2">Loan and Lease Recoveries</Typography>

        <Typography variant="body2">
          -- 1984-1989 -- Represents actual loan and lease recoveries credited
          to the allowance for loan and lease losses. Not collected by TFR
          filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents actual loan and lease recoveries
          credited to the allowance for loan and lease losses.
        </Typography>

        <Typography variant="body2">Net Loan and Lease Charge-offs</Typography>

        <Typography variant="body2">
          -- 1984-1989 -- Represents Loan and Lease Charge-offs less Loan and
          Lease Recoveries. An amount enclosed in parentheses indicates net
          recoveries. Not collected by TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents Loan and Lease Charge-offs less Loan and
          Lease Recoveries. An amount enclosed in parentheses indicates net
          recoveries.
        </Typography>

        <Typography variant="body2">
          Cash Dividends Declared (Preferred) -- Represents all cash dividends
          declared on limited life and perpetual preferred stock during the
          calendar year, regardless of when payable.
        </Typography>

        <Typography variant="body2">
          Cash Dividends Declared (Common) -- Represents all cash dividends
          declared in all classes of common stock during the calendar year,
          regardless of when payable.
        </Typography>

        <Typography variant="body2">
          Total Cash Dividends Declared -- Represents all cash dividends
          declared on all classes of preferred and common stock during the
          calendar year, regardless of when payable.
        </Typography>

        <Typography variant="body2">Number of Full Time Employees</Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Represents the number of full time equivalent
          employees on the payroll as of each year end. Not collected by TFR
          filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents the number of full time equivalent
          employees on the payroll as of each year end.
        </Typography>

        <Typography variant="body2">
          Number of Institutions -- Represents the number of institutions filing
          12/31 financial report.
        </Typography>

        <Typography variant="h2" id="Assets">
          Assets
        </Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">Significant Events</Typography>

        <Typography variant="body2">
          1984 -- Deposit insurance for mutual savings banks (savings banks with
          no capital stock that accept only, with a few exceptions, savings
          deposits and whose earnings inure to the benefit of the depositor).
          These banks include those operating under special state banking codes
          applicable to mutual savings banks and all guaranty savings banks in
          New Hampshire and all insured savings banks in Massachusetts.
        </Typography>

        <Typography variant="body2">
          1984 -- Deposit insurance for all savings and loan associations and
          all federally insured savings banks not insured by the FDIC provided
          by the Federal Savings and Loan Insurance Corporation (FSLIC).
        </Typography>

        <Typography variant="body2">
          1989 -- Financial Institutions Reform, Recovery, and Enforcement Act
          (FIRREA) passed. FIRREA created and funded a government agency, the
          Resolution Trust Corporation (RTC) to manage and dispose of, either
          through sale or liquidation, any failed savings institution
          transferred from OTS through September 30, 1993. FIRREA specified that
          any funds needed to protect the depositors of these failed savings
          institutions would be publicly provided until the termination of the
          RTC on December 31, 1996. Additionally, FIRREA specified that the FDIC
          would be the sole insurer of all financial institutions, and that
          institutions would acquire deposit insurance through either the Bank
          Insurance Fund (BIF) or the Savings Association Insurance Fund (SAIF)
          depending upon their charter. The SAIF replaced the FSLIC insurance
          fund. Further, FIRREA specified that any acquisition of deposits
          insured by a fund other than the acquiring institution's must maintain
          a percentage in both insurance funds equivalent to the membership
          percentage at the date of acquisition. Regulatory supervision
          continued to be provided by the FDIC and the OTS depending upon the
          charter of the institution.
        </Typography>

        <Typography variant="body2">
          1993-present -- The RTC Completion Act extends the RTC's
          responsibility to accept failed savings institutions from OTS through
          July 1, 1995 and terminates the RTC on December 31, 1995. Funding for
          future failures of savings institutions to be borne by either the BIF
          or SAIF.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          Total Savings Institutions -- Represents the total number of insured
          savings institutions submitting Call or TFR reports. This number may
          differ from the actual count of institutions in other tables due to
          the exclusion of institutions active on December 31 that did not
          submit a Call or TFR report. This occurs most often when a bank is
          merged or closed on or just after December 31.
        </Typography>

        <Typography variant="body2">
          Cash and Due from Depository Institutions
        </Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Represents currency and coin, balances due from
          institutions, and cash items. Excludes interest earning deposits in
          FHLB's for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents currency and coin, balances due from
          institutions, and cash items.
        </Typography>

        <Typography variant="body2">Total Investment Securities</Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Represents securities of the U.S. Treasury, the U.S.
          Government, direct and guaranteed, US Government agencies and
          corporations, obligations of states, counties and municipalities,
          corporate bonds, other bonds, notes and debentures, and equity
          securities. The amount is net of valuation allowances. For TFR filers,
          balances include interest-earning deposits in FHLBs, other
          interest-earning deposits, federal funds sold and assets held in
          trading accounts.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents securities of the U.S. Treasury, the
          U.S. Government, direct and guaranteed, US Government agencies and
          corporations, obligations of states, counties and municipalities,
          corporate bonds, other bonds, notes and debentures, and equity
          securities. The amount is net of valuation allowances and excludes
          assets held in trading accounts.
        </Typography>

        <Typography variant="body2">Total Loans and Leases</Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Represents the total of all loans and leases, net of
          unearned income, loans in process, and unamortized yield adjustments.
          For TFR filers this item is net of unamortized yield adjustments for
          mortgage pool securities.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents the total of all loans and leases, net
          of unearned income, loans in process, and unamortized yield
          adjustments.
        </Typography>

        <Typography variant="body2">
          Allowance for Losses Loan and Lease
        </Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Represents the allowance for losses on loans and
          leases. Includes allowance for mortgage pool securities for TFR
          filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents the allowance for losses on loans and
          leases.
        </Typography>

        <Typography variant="body2">
          Net Loans and Leases -- Represents Total Loans &amp; Leases less the
          Reserve for Loan &amp; Lease Losses.
        </Typography>

        <Typography variant="body2">Other Earning Assets</Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Represents Federal funds sold and securities purchased
          under agreements to resell (repurchase agreements). Items not
          separately reported by TFR filers. They are included in Securities.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents Federal funds sold and securities
          purchased under agreements to resell (repurchase agreements). Includes
          only federal funds sold for TFR filers. Repurchase agreements are
          included in
        </Typography>

        <Typography variant="body2">
          Bank Premises and Equipment -- Represents bank premises, furniture and
          equipment, net of depreciation.
        </Typography>

        <Typography variant="body2">
          Other Real Estate -- Represents other real estate owned net of
          reserves for losses.
        </Typography>

        <Typography variant="body2">
          Intangible Assets -- Represents goodwill, mortgage servicing rights,
          and other identifiable intangible assets.
        </Typography>

        <Typography variant="body2">
          All Other Assets -- Same as above except that investment in service
          corporations/subsidiaries is reported gross of valuation allowances by
          TFR filers, and assets held in trading accounts are included in
          Securities for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-Present -- Represents all association assets not previously
          mentioned. Includes all non real estate repossessed property,
          investment in service corporations/subsidiaries, property leased to
          others, income earned but not yet collected, assets held in trading
          accounts, and miscellaneous assets.
        </Typography>

        <Typography variant="body2">
          Total Assets -- The total of all asset components.
        </Typography>

        <Typography variant="h2" id="Investment Securities">
          Investment Securities
        </Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">U.S. Treasury Securities</Typography>

        <Typography variant="body2">
          -- 1984-1988 -- Not separately reported. Included in U.S. Treasury,
          Agencies &amp; Corporations.
        </Typography>

        <Typography variant="body2">
          -- 1989 -- Represents all obligations of the U.S. Treasury - bills,
          notes and bonds. Only includes Call Report filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-1995 -- Represents all obligations of the U.S. Treasury -
          bills, notes and bonds. Includes securities held in trading accounts
          for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1996-present -- Represents all obligations of the U.S. Treasury -
          bills, notes and bonds. Only includes Call Report filers.
        </Typography>

        <Typography variant="body2">
          U.S. Agencies, and Corporations Securities
        </Typography>

        <Typography variant="body2">
          -- 1984-1986 -- Included in U.S. Treasury, Agencies &amp; Corporations
          and includes securities held in trading accounts for TFR filers. Does
          not include mortgage derivative Securities for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1987-1988 -- Included in U.S. Treasury, Agencies &amp; Corporations
          and includes securities held in trading accounts for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1989 -- Represents all obligations of U.S. agencies and
          corporations, both direct and guaranteed by the U. S. Government. Only
          includes Call Report filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-1995 -- Represents all obligations of U.S. agencies and
          corporations, both direct and guaranteed by the U. S. Government.
          Includes securities held in trading accounts for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1996-present -- Represents all obligations of U.S. agencies and
          corporations, both direct and guaranteed by the U. S. Government. Only
          includes Call Report filers.
        </Typography>

        <Typography variant="body2">
          -- 2001-present -- Includes all other U.S. government agency and
          corporation obligations on a consolidated basis.
        </Typography>

        <Typography variant="body2">
          U.S. Treasury, Agencies &amp; Corporations Securities
        </Typography>

        <Typography variant="body2">
          -- 1984-Present -- Includes all obligations of U.S. Government
          agencies and corporations, both guaranteed and not guaranteed.
          Includes securities held in trading accounts for TFR filers.
        </Typography>

        <Typography variant="body2">
          States &amp; Political Subdivisions Securities
        </Typography>

        <Typography variant="body2">
          -- 1984-1989 -- Represents all obligations (other than loans) of
          states and political subdivisions in the United States. Not reported
          separately by TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents all obligations (other than loans) of
          states and political subdivisions in the United States. Includes
          securities held in trading accounts for TFR filers.
        </Typography>

        <Typography variant="body2">Other Debt Securities</Typography>

        <Typography variant="body2">
          -- 1984-1989 -- Same as above, except that States and Political
          Subdivisions are included for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Includes all bonds, notes and debentures of
          domestic corporations and foreign bonds, notes and debentures, both
          public and private. Includes securities held in trading accounts for
          TFR filers. Does not include privately-issued collateralized mortgage
          obligations (including REMICS) for TFR filers.
        </Typography>

        <Typography variant="body2">
          Equity Securities -- Includes all preferred and common stock, mutual
          funds and Federal Reserve Stock. Does not include FHLB stock.
        </Typography>

        <Typography variant="body2">
          Less: Contra Accounts -- Represents amounts reported by savings
          institutions that file on the Thrift Financial Report. Contra accounts
          include accrued interest receivable, unamortized yield adjustments and
          valuation allowances. Negative amounts reflect unamortized premiums
          and deferred direct costs exceeding unamortized discounts and deferred
          loan fees.
        </Typography>

        <Typography variant="body2">
          Less: Trading Accounts -- 1990-present -- Represents securities held
          or acquired for the purpose of sale. Only includes TFR filers. Call
          Report filers collect details of securities without trading accounts.
        </Typography>

        <Typography variant="body2">
          Total Investment Securities (Book Value)
        </Typography>

        <Typography variant="body2">
          -- 1984-1989 -- Represents the total of all securities, both domestic
          and foreign, net of valuation reserves. For TFR filers this amount
          includes interest-earning deposits in FHLBs, other interest-earning
          deposits, federal funds sold and assets held in trading accounts.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents the total of all securities, both
          domestic and foreign, net of valuation reserves, contra accounts and
          trading accounts.
        </Typography>

        <Typography variant="body2">
          Memo: Mortgage Backed Securities -- Represents mortgage backed
          securities on a consolidated basis. Includes U.S. government agency
          and corporation obligations issued or guaranteed certificates of
          participation in pools of residential mortgages, U.S. government
          agency and corporation obligations, collateralized mortgage
          obligations issued by Federal National Mortgage Association (FNMA) and
          Federal Home Loan Mortgage Corporation (FHLMC) (including REMICS),
          other domestic debt securities - private (i.e., non-government issued
          or guaranteed) certificates of participations in pools of residential
          mortgages, and other domestic debt securities - privately-issued
          collateralized mortgage obligations (including REMICS).
        </Typography>

        <Typography variant="h2" id="Loans and Leases">
          Loans and Leases
        </Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">Total Real Estate Loans</Typography>
        <Typography variant="body2">
          -- 1984-1987 -- Represents all loans secured by real estate. For TFR
          filers this figure excludes revolving loans secured by 1-4 family
          dwelling units and home equity loans based on the creditworthiness of
          the borrower. They are included in To Individuals.
        </Typography>

        <Typography variant="body2">
          -- 1988-present -- Represents all loans secured by real estate.
        </Typography>

        <Typography variant="body2">
          Loans to Depository Institutions
        </Typography>
        <Typography variant="body2">
          -- 1984-1985 -- Represents all loans to domestic and foreign
          commercial banks and other financial institutions. Not separately
          collected by TFR filers, included in Commercial and Industrial.
        </Typography>

        <Typography variant="body2">
          -- 1986-1988 -- Loans to financial institutions are included in All
          Other Loans. Not separately collected by TFR filers, included in
          Commercial and Industrial.
        </Typography>

        <Typography variant="body2">
          -- 1989-present -- Represents all loans to domestic and foreign
          commercial banks and other financial institutions. Not separately
          collected by TFR filers, included in Commercial and Industrial.
        </Typography>

        <Typography variant="body2">Agricultural Loans</Typography>
        <Typography variant="body2">
          -- 1984-1985 -- Represents all loans to farmers and loans for
          agricultural production. Not separately collected by TFR filers,
          included in Commercial and Industrial.
        </Typography>

        <Typography variant="body2">
          -- 1986-1988 -- Included in All Other Loans. Not separately collected
          by TFR filers, included in Commercial and Industrial.
        </Typography>

        <Typography variant="body2">
          -- 1989-present -- Represents all loans to farmers and loans for
          agricultural production. Not separately collected by TFR filers,
          included in Commercial and Industrial.
        </Typography>

        <Typography variant="body2">
          Commercial and Industrial Loans -- Represents all loans and commercial
          paper for commercial or industrial purposes. For TFR filers, includes
          loans to financial institutions and agricultural production loans.
        </Typography>

        <Typography variant="body2">Total Loans To Individuals</Typography>
        <Typography variant="body2">
          -- 1984-1987 -- Represents all loans to individuals to finance autos,
          home improvement, and personal expenses. It includes both installment
          and single payment loans. For TFR filers includes revolving loans
          secured by 1-4 family dwelling units and home equity loans based on
          the creditworthiness of the borrower.
        </Typography>

        <Typography variant="body2">
          -- 1988-present -- Represents all loans to individuals to finance
          autos, home improvement, and personal expenses. It includes both
          installment and single payment loans.
        </Typography>

        <Typography variant="body2">
          Loans to States &amp; Political Subdivisions -- Represents all
          obligations (other than securities), direct loans and Industrial
          Development Bonds that have the characteristics of loans. Not
          separately collected by TFR filers, included in Commercial and
          Industrial.
        </Typography>

        <Typography variant="body2">
          All Other Loans -- Represents all loans not categorized above, such as
          loans to brokers and dealers in securities, loans for purchasing or
          carrying securities, loans to finance and investment companies, loans
          to holding companies of financial institutions and loans to
          individuals for investment purposes.
        </Typography>

        <Typography variant="body2">
          Leases -Lease Financing Receivables -- 1986-present -- Represents all
          outstanding receivable balances relating to direct financing and
          leveraged leases on property acquired by the institution for leasing
          purposes.
        </Typography>

        <Typography variant="body2">
          Less: Unearned Income -- Represents the amount of income collected but
          not earned on loans.
        </Typography>

        <Typography variant="body2">Less: Other Contras Accounts</Typography>
        <Typography variant="body2">
          -- 1984-1989 -- For TFR filers, includes advances for taxes and
          insurance, loans in process on mortgages and nonmortgages, unamortized
          yield adjustments for mortgages and nonmortgages. Includes Unamortized
          yield adjustments on mortgage pool securities. Does not include Call
          report filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- For TFR filers, includes advances for taxes and
          insurance, loans in process on mortgages and nonmortgages, unamortized
          yield adjustments for mortgages and nonmortgages. Does not include
          Call report filers.
        </Typography>

        <Typography variant="body2">Total Loans &amp; Leases</Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Represents the sum of all components of loans. For TFR
          filers this item is net of unamortized yield adjustments for mortgage
          pool securities.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents the sum of all components of loans.
        </Typography>

        <Typography variant="body2">
          Less: Allowance for Losses Loan and Lease
        </Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Represents the allowance for possible loan and lease
          losses. For TFR filers, includes allowance for mortgage pool
          securities.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents the allowance for possible loan and
          lease losses, both general and specific reserves for TFR filers.
        </Typography>

        <Typography variant="body2">Net Loans &amp; Leases</Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Represents gross loans and leases less unearned
          income, other contra accounts, and the allowance for possible losses
          on loans and leases. For TFR filers this item is net of unamortized
          yield adjustments for mortgage pool securities.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents gross loans and leases less unearned
          income, other contra accounts, and the allowance for possible losses
          on loans and leases.
        </Typography>

        <Typography variant="h2" id="Real Estate Loans">
          Real Estate Loans
        </Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          Real Estate Loans -Construction and Land Development -- Represents
          loans secured by real estate made to finance land development
          preparatory to erecting new structures or the on-site construction of
          industrial, commercial, residential or farm buildings. Also includes
          loans made to acquire and improve developed and undeveloped land for
          TFR filers.
        </Typography>

        <Typography variant="body2">
          Real Estate Loans - 1-4 Family Residential Properties
        </Typography>

        <Typography variant="body2">
          -- 1984-1987 -- Represents loans secured by real estate as evidenced
          by mortgages (FHA, FMHA, VA, or conventional) or other liens on 1-4
          family dwelling units, mobile homes, individual condominiums and
          co-ops, and vacant lots in established single family residential
          sections. For TFR filers, this figure excludes home equity loans based
          on the creditworthiness of the borrower.
        </Typography>

        <Typography variant="body2">
          -- 1988-present -- Represents loans secured by real estate as
          evidenced by mortgages (FHA, FMHA, VA, or conventional) or other liens
          on 1-4 family dwelling units, mobile homes, individual condominiums
          and co-ops, and vacant lots in established single family residential
          sections.
        </Typography>

        <Typography variant="body2">
          Real Estate Loans - Multifamily Residential Properties -- Represents
          permanent nonfarm residential loans secured by five or more dwelling
          unit real estate as evidenced by mortgages (FHA and conventional) or
          other liens on apartments, housekeeping dwellings, co-operative type
          apartment buildings, and vacant lots in established multifamily
          residential sections.
        </Typography>

        <Typography variant="body2">
          Real Estate Loans Non-farm, Non-residential Properties -- Represents
          loans secured by real estate as evidenced by mortgages or other liens
          on business and industrial properties, farm properties, hotels,
          motels, churches, hospitals, educational and charitable institutions,
          dormitories, clubs, lodges, association buildings, homes for aged
          persons, golf courses, recreational facilities and other similar
          properties.
        </Typography>

        <Typography variant="body2">
          Total Real Estate Loans -- Represents the sum of the components of
          loans secured by real estate.
        </Typography>

        <Typography variant="body2">Memo: Contra Accounts</Typography>

        <Typography variant="body2">
          -- 1984-1989 -- Represents accounts not reflected in individual loan
          categories for institutions completing the Thrift Financial Report. It
          includes loans in process, unamortized yield adjustments and reserves.
          For TFR filers includes allowance for mortgage pool securities.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents accounts not reflected in individual
          loan categories for institutions completing the Thrift Financial
          Report. It includes loans in process, unamortized yield adjustments
          and reserves.
        </Typography>

        <Typography variant="body2">
          Memo: Home Equity Loans -- Represents revolving, open-end loans
          secured by 1-4 family residential properties and extended under lines
          of credit held in domestic offices.
        </Typography>

        <Typography variant="body2">Loans to Individuals</Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="h2" id="Field Content">
          Field Content
        </Typography>

        <Typography variant="body2">
          Loans to Individuals - Credit Cards and Related Plans -- Represents
          all credit extended to individuals for household, family and other
          personal expenditures through credit cards and related plans. The
          amount represents the amount borrowed, not the established line of
          credit.
        </Typography>

        <Typography variant="body2">
          -- 2001-present -- Includes Consumer Related Plans.
        </Typography>

        <Typography variant="body2">
          {" "}
          Loans to Individuals - Home Improvement Loans
        </Typography>
        <Typography variant="body2">
          -- 1984-1985 -- Represents all closed-end loans based on the
          creditworthiness of the borrower for the equipping, alteration,
          repair, or improvement of 1-4 dwelling units.
        </Typography>

        <Typography variant="body2">
          -- 1986-present -- Represents all closed-end loans based on the
          creditworthiness of the borrower for the equipping, alteration,
          repair, or improvement of 1-4 dwelling units. This amount is reported
          in All Other for Call report filers.
        </Typography>

        <Typography variant="body2">
          All Other Loans to Individuals -- Represents all other installment
          loans to individuals for household, family and other personal
          expenditures. It includes auto loans, both direct and indirect, mobile
          home loans (unless secured by a real estate mortgage), education
          loans, and other installment loans both secured by personal property
          or unsecured, and single payment loans (time or demand, secured or
          unsecured). Includes home improvement loans for Call report filers.
        </Typography>

        <Typography variant="body2">
          Total Loans to Individuals -- Represents the sum of all components of
          loans to individuals.
        </Typography>

        <Typography variant="h2" id="Liabilities and Equity Capital">
          Liabilities and Equity Capital
        </Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">17.2 Significant Events</Typography>

        <Typography variant="body2">
          1989 -- Deposit insurance for mutual savings banks (savings banks with
          no capital stock that accept only, with a few exceptions, savings
          deposits and whose earnings inure to the benefit of the depositor).
          These banks include those operating under special state banking codes
          applicable to mutual savings banks and all guaranty savings banks in
          New Hampshire and all insured savings banks in Massachusetts.
        </Typography>

        <Typography variant="body2">
          1989 -- Deposit insurance for all savings and loan associations and
          all federally insured savings banks not insured by the FDIC provided
          by the Federal Savings and Loan Insurance Corporation (FSLIC).
        </Typography>

        <Typography variant="body2">
          1989 -- Financial Institutions Reform, Recovery, and Enforcement Act
          (FIRREA) passed. FIRREA created and funded a government agency, the
          Resolution Trust Corporation (RTC) to manage and dispose of, either
          through sale or liquidation, any failed savings institution
          transferred from OTS through September 30, 1993. FIRREA specified that
          any funds needed to protect the depositors of these failed savings
          institutions would be publicly provided until the termination of the
          RTC on December 31, 1996. Additionally, FIRREA specified that the FDIC
          would be the sole insurer of all financial institutions, and that
          institutions would acquire deposit insurance through either the Bank
          Insurance Fund (BIF) or the Savings Association Insurance Fund (SAIF)
          depending upon their charter. The SAIF replaced the FSLIC insurance
          fund. Further, FIRREA specified that any acquisition of deposits
          insured by a fund other than the acquiring institution's must maintain
          a percentage in both insurance funds equivalent to the membership
          percentage at the date of acquisition. Regulatory supervision
          continued to be provided by the FDIC and the OTS depending upon the
          charter of the institution.
        </Typography>

        <Typography variant="body2">
          1993-present -- The RTC Completion Act extends the RTC's
          responsibility to accept failed savings institutions from OTS through
          July 1, 1995 and terminates the RTC on December 31, 1995. Funding for
          future failures of savings institutions to be borne by either the BIF
          or SAIF.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">Liabilities</Typography>
        <Typography variant="body2">
          Total Savings Institutions -- Represents the total number of insured
          savings institutions submitting Call reports or TFR reports. This
          number may differ from the actual count of institutions in other
          tables due to the exclusion of institutions active on December 31 that
          did not submit a Call report or TFR report. This occurs most often
          when a bank is merged or closed on or just after December 31.
        </Typography>

        <Typography variant="body2">
          Total Deposits -- Includes all categories and types of deposits.
        </Typography>

        <Typography variant="body2">
          Borrowed Funds -- Includes federal funds purchased, securities sold
          under agreements to repurchase (reverse repurchase agreements), demand
          notes issued to the US Treasury, mortgage indebtedness, liabilities
          under capitalized leases and all other liabilities for borrowed money.
          Includes only reverse repurchase agreements (securities sold under
          agreements to repurchase) and FSLIC net worth certificates for TFR
          filers.
        </Typography>

        <Typography variant="body2">
          Subordinated Notes -- Includes all notes and debentures subordinated
          to secured creditors.
        </Typography>

        <Typography variant="body2">
          Other Liabilities -- Includes all liabilities not included above and
          limited life preferred stock.
        </Typography>

        <Typography variant="body2">
          2001-present-- Includes OTHER LIAB &amp; MINOR IN SUBS.
        </Typography>

        <Typography variant="body2">
          Total Liabilities -- Represents the total of all liability components
          and limited life preferred stock.
        </Typography>

        <Typography variant="body2">Equity Capital</Typography>
        <Typography variant="body2">
          Perpetual Preferred stock -- Includes all preferred stock issued and
          outstanding at par value.
        </Typography>

        <Typography variant="body2">
          Common stock -- Includes all common stock issued and outstanding at
          par value.
        </Typography>

        <Typography variant="body2">
          Surplus -- Represents stock surplus and surplus related accounts.
        </Typography>

        <Typography variant="body2">
          Undivided Profits -- Represents undivided profits, capital reserves
          and related accounts.
        </Typography>

        <Typography variant="body2">
          FDIC Net Worth Certificates -- Represents net worth certificates
          issued to the FDIC or to the Mutual Savings Central Fund or the
          Cooperative Central Bank in Massachusetts. Not reported by TFR filers
          which held FSLIC net worth certificates, which are included in Other
          Borrowings.
        </Typography>

        <Typography variant="body2">
          Total Equity Capital -- Represents the total of all capital
          components, including FDIC net worth certificates.
        </Typography>

        <Typography variant="body2">
          Total Liabilities and Equity Capital -- Represents the sum of all
          liability and all capital components. Beginning in 2009, Total
          Liability and Equity includes Equity from Non Controlling Interest
          (eqconsub).
        </Typography>

        <Typography variant="h2" id="Deposits">
          Deposits
        </Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          Total Deposits -- Includes all categories and all types of deposits.
        </Typography>

        <Typography variant="body2">
          Deposits – Domestic Demand -- Includes all noninterest-bearing
          deposits that are payable immediately on demand, or that are issued
          with an original maturity or required notice period of less than seven
          days, or that represent funds for which the depository institution
          does not reserve the right to require at least seven days written
          notice of an intended withdrawal. Demand deposits include any matured
          time deposits without automatic renewal provisions, unless the deposit
          agreement provides for the funds to be transferred at maturity to
          another type of account.
        </Typography>

        <Typography variant="body2">
          Memo: Time Deposits (Over $100K) -- Represents any time deposit in an
          amount greater than 100,000 dollars. Includes brokered deposits issued
          to brokers or dealers in the form of large ($100,000 or more)
          certificates of deposit, regardless of whether the underlying
          depositor's shares are in denominations of less than $100,000.
        </Typography>

        <Typography variant="body2">
          Memo: IRA's – Keogh Plan Deposits -- Represents the amount of
          Individual Retirement Accounts (IRA's) and Keogh Plan accounts.
        </Typography>

        <Typography variant="body2">
          Memo: Brokered Deposits -- Represents funds which the reporting bank
          obtains, directly or indirectly, by or through any deposit broker for
          deposit into one or more deposit accounts. Includes both those in
          which the entire beneficial interest in a given bank deposit account
          or investment is held by a single depositor and those in which the
          deposit broker sells participation in a given bank deposit account or
          instrument to one or more investors.
        </Typography>

        <Typography
          variant="h2"
          id="Interest Earning Assets and Interest Bearing
Liabilities"
        >
          Interest Earning Assets and Interest Bearing Liabilities
        </Typography>

        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports(TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">Interest Earning Balances</Typography>
        <Typography variant="body2">
          -- 1984-1985 -- Not reported separately.
        </Typography>
        <Typography variant="body2">
          -- 1986-1989 -- Represents interest bearing balances due from
          institutions and other financial institutions. Not reported separately
          by TFR filers.
        </Typography>
        <Typography variant="body2">
          -- 1990-present -- Represents interest bearing balances due from
          institutions and other financial institutions.
        </Typography>

        <Typography variant="body2">
          Total Investment Securities (Book Value)
        </Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Same as above except that for TFR filers, it includes
          interest-earning deposits in FHLBs, other interest-earning deposits,
          federal funds sold and assets held in trading accounts.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents securities of the U.S. Treasury; U.S.
          Government, both direct and guaranteed, U.S. agencies and
          corporations; obligations of states, counties and municipalities;
          corporate bonds; other bonds, notes and debentures and equity
          securities.
        </Typography>

        <Typography variant="body2">Net Loans and Leases</Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Represents gross loans and leases less unearned
          Income, reserves for losses, loans in process, and unamortized yield
          adjustments. For TFR filers this item is net of unamortized yield
          adjustments for mortgage pool securities.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents gross loans and leases less unearned
          income, reserves for losses, loans in process, and unamortized yield
          adjustments.
        </Typography>

        <Typography variant="body2">Federal Funds Sold</Typography>
        <Typography variant="body2">
          -- 1984-1989 -- Same as above except that it is not separately
          reported by TFR filers and is included in Securities.
        </Typography>

        <Typography variant="body2">
          -- 1990-present -- Represents Federal funds sold and securities
          purchased under agreements to resell (repurchase agreements). Includes
          only federal funds sold for TFR filers.
        </Typography>

        <Typography variant="body2">Trading Account Assets</Typography>
        <Typography variant="body2">
          -- 1984-1985 -- Included in individual asset categories.
        </Typography>
        <Typography variant="body2">
          -- 1986-1989 -- Represents all trading account assets. Not separately
          reported by TFR filers, reported in Securities.
        </Typography>
        <Typography variant="body2">
          -- 1990-present -- Represents all trading account assets.
        </Typography>

        <Typography variant="body2">
          Total Interest Bearing Assets -- Represents the sum of all interest
          bearing assets.
        </Typography>

        <Typography variant="body2">Interest Bearing Deposits</Typography>
        <Typography variant="body2">
          -- 1984-1992 -- Represents any deposit on which the bank pays or
          accrues interest.
        </Typography>

        <Typography variant="body2">
          -- 1993-present -- Represents any deposit for which the bank pays or
          accrues interest. Represents all deposits for TFR filers since
          interest-bearing deposits are no longer required to be separately
          reported for institutions with less than $300 million in assets or
          institutions that have a capital ratio of greater than 12%.
        </Typography>

        <Typography variant="body2">
          Federal Funds Purchased/Securities Sold -- Represents all federal
          funds purchased. Includes only reverse repurchase agreements
          (securities sold under agreement to repurchase) for TFR filers.
        </Typography>

        <Typography variant="body2">
          Advances From FHLB -- Represents all borrowings from FHLBanks. Only
          reported by TFR filers.
        </Typography>

        <Typography variant="body2">
          Demand Notes and Other Borrowings -- Represents demand notes issued to
          the U.S. Treasury (Treasury tax &amp; loan account), and all other
          borrowings. Includes mortgage indebtedness and liabilities under
          capitalized leases for Call report filers. Includes FSLIC net worth
          certificates for TFR filers.
        </Typography>

        <Typography variant="body2">
          Subordinated Notes -- Represents notes and debentures subordinated to
          secured creditors.
        </Typography>

        <Typography variant="body2">
          FDIC Net Worth Certificates -- 1984-1993 -- Represents net worth
          certificates issued to the FDIC or to the Mutual Savings Central Fund
          or the Cooperative Central Bank in Massachusetts. Reported by TFR
          filers in Demand Notes and Other Borrowings.
        </Typography>

        <Typography variant="body2">
          Total Interest Bearing Liabilities -- Represents the sum of all
          interest bearing liabilities.
        </Typography>

        <Typography variant="h2" id="Past Due and Nonaccrual Loans/Leases">
          Past Due and Nonaccrual Loans/Leases
        </Typography>
        <Typography variant="body2">General Comments</Typography>
        <Typography variant="body2">
          0 Represents a positive amount less than $500
        </Typography>
        <Typography variant="body2">
          (0) Represents a negative amount less than $(500)
        </Typography>
        <Typography variant="body2">
          NA Not available or not applicable
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured savings institutions includes all
          institutions insured by either the Bank Insurance Fund (BIF) or the
          Savings Association Insurance Fund (SAIF) that operate under state or
          federal banking codes applicable to thrift institutions, except for
          one self-liquidating institution primarily funded by the FSLIC
          Resolution Fund (FRF). Savings institutions that have been placed in
          Resolution Trust Corporation conservatorship are also excluded from
          these tables while in conservatorship. The institutions covered in
          this section are regulated by and submit financial reports to one of
          two Federal regulators -- the Federal Deposit Insurance Corporation
          (FDIC) or the Office of Thrift Supervision (OTS). Data for the savings
          institutions regulated by the FDIC are from the Federal Financial
          Institution Examination Council (FFIEC) Reports of Income and
          Condition submitted to the FDIC (Call Reports). Data for savings
          institutions regulated by the Office of Thrift Supervision (OTS) are
          from the Thrift Financial Reports (TFR).
        </Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. The notes below identify any significant adjustments or
          changes in definitions from current requirements. Certain adjustments
          are made to the OTS Thrift Financial Reports to provide closer
          conformance with the reporting and accounting requirements of the Call
          Reports. These notes are an integral part of this publication and
          provide information regarding the comparability of source data and
          reporting differences over time.
        </Typography>

        <Typography variant="body2">20.2 Field Content</Typography>

        <Typography variant="body2">
          Loans and Leases Past Due 30-89 Days
        </Typography>
        <Typography variant="body2">
          -- 1984-1985 -- Not collected by either Call report or TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1986-1989 -- Represents all loans and leases that are 30-89 days
          past due. Not collected by TFR filers. TFR filers collected loans
          delinquent by more than 60 days and loans past due by at least one
          payment missed.
        </Typography>

        <Typography variant="body2">
          -- 1990-1995 -- Represents all loans and leases that are 30-89 days
          past due.
        </Typography>

        <Typography variant="body2">
          -- 1996-present -- Beginning in 1996, all loans and leases that are
          30-89 days past due are shown net of specific reserves for TFR filers.
          For Call Report filers, loans and leases that are 30-89 days past due
          are shown net of specific reserves.
        </Typography>

        <Typography variant="body2">
          Loans and Leases Past Due 90 Days or More
        </Typography>
        <Typography variant="body2">
          -- 1984-1985 -- Not collected by either Call report or TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1986-1989 -- Represents all loans and leases that are 90 days or
          more past due. Not collected by TFR filers. TFR filers collected loans
          delinquent by more than 60 days and loans past due by at least one
          payment missed.
        </Typography>

        <Typography variant="body2">
          -- 1990-1995 -- Represents all loans and leases that are 90 days or
          more past due.
        </Typography>

        <Typography variant="body2">
          -- 1996-present -- Beginning in 1996, all loans and leases that are 90
          days or more past due are shown net of specific reserves for TFR
          filers. For Call Report filers, loans and leases that are 90 days or
          more past due are shown net of specific reserves.
        </Typography>

        <Typography variant="body2">Total Loans and Leases Past Due</Typography>
        <Typography variant="body2">
          ---Total of all loans and leases past due 30 days or more
        </Typography>

        <Typography variant="body2">
          Total Non-accrual Loans and Leases
        </Typography>
        <Typography variant="body2">
          -- 1984-1985 -- Not collected by either Call report or TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1986-1989 -- Same as above except that TFR did not collect this
          item. TFR filers collected loans delinquent by 60 days or more and
          loans past due by at least one payment missed.
        </Typography>

        <Typography variant="body2">
          -- 1990-1995 -- Represents all loans and leases that (a) are
          maintained on a cash basis because of deterioration in the financial
          position of the borrower, (b) payment in full of interest and
          principal is not expected or (c) principal or interest has been in
          default for a period of 90 days or more unless the obligation is both
          well secured and in the process of collection.
        </Typography>

        <Typography variant="body2">
          -- 1996-present -- Beginning in 1996, nonaccrual loans and leases are
          shown net of specific reserves for TFR filers. For Call Report filers,
          nonaccrual loans are shown net of specific reserves.
        </Typography>

        <Typography variant="body2">
          Total Non-current Loans &amp; Leases
        </Typography>
        <Typography variant="body2">
          -- 1984-1985 -- Represents delinquent loans (60 or more days overdue)
          and past due loans (one or more payments missed) for TFR filers.
        </Typography>

        <Typography variant="body2">
          Not collected by Call report filers.
        </Typography>
        <Typography variant="body2">
          -- 1986-1989 -- Represents all loans and leases past due 90 days or
          more and still accruing plus all loans and leases in a nonaccrual
          status. Includes delinquent loans (60 or more days overdue) and past
          due loans (one or more payments missed) for TFR filers.
        </Typography>

        <Typography variant="body2">
          -- 1990-1995 -- Represents all loans and leases past due 90 days or
          more and still accruing plus all loans and leases in a nonaccrual
          status.
        </Typography>

        <Typography variant="body2">
          -- 1996-present -- Beginning in 1996, all loans and leases past due 90
          days or more and still accruing plus all loans and leases in a
          nonaccrual status are shown net of specific reserves for TFR filers.
          For Call Report filers, these loans and leases are shown net of
          specific reserves.
        </Typography>
      </>
    </>
  );
}
